// BF 只在受尺寸选择器影响的商品链接上带这两个英寸参数；普通 PDP 保持原来的记忆优先级。
function readBfSelectedSize () {
  if (searchParams.get('cartpopup') != null) return null;
  const values = ['bf_width', 'bf_length'].map(key => searchParams.getAll(key));
  if (values.some(items => items.length !== 1 || !/^\d+$/.test(items[0]))) return null;
  const [width, length] = values.map(items => Number(items[0]));
  return Number.isSafeInteger(width) && Number.isSafeInteger(length) && width > 0 && length > 0
    ? { width, length } : null;
}

function restoreBfSelectedSize (size) {
  // 两个维度都能被当前产品接受才带入；不绕过原有的范围、单位和 Fraction 约束。
  const valid = ['width', 'length'].every(dim => {
    const input = sizeInputFor(dim);
    const value = sizeToCurrentUnit(size[dim]);
    return input.length && !sizeHasFraction(dim) && value >= Number(input.attr('min')) && value <= Number(input.attr('max'));
  });
  if (!valid) return false;
  let filled = false;
  sizeMemoryRestoring = true;
  try {
    filled = fillSizeInput('width', size.width);
    filled = fillSizeInput('length', size.length) && filled;
  } finally {
    sizeMemoryRestoring = false;
  }
  if (filled) showSizeMemoryNote();
  return filled;
}

function bcpoLoad () {
  if (!isCafe) {
    $('.bcpo-image-parent:has(input[value*="Double Rod Pocket" i])').remove();
  }

  // LINING 内衬
  if (isIndoor && !isDoor && !isSheer && !isCafe && !product.title.toLowerCase().includes('4 layer')) {
    if (product["visulized-tool"]?.shadingOptions) {
      $('.selector-wrapper:has(input[name="properties[LINING]"])').append($('.liningPre'));
      if ($('input[name="properties[LINING]"]:checked').length > 0) {
        const type = $('input[name="properties[LINING]"]:checked').val();
        $('input[name="properties[LINING]"]:checked').prop('checked', false);
        // 取消后再点回同一个值，让 label 的点击逻辑（liningPre 等）跑一遍。原来写成字面量 [value="type"]，
        // 什么都点不到 → BCPO 预选的 Unlined 被清空（2026-09-26 修）。用 filter 比较，值里的引号等字符不会打断选择器。
        // 猜你喜欢加购弹窗（component-cart-edit.js）也按 BCPO 预选，两边默认一致。
        $('input[name="properties[LINING]"]').filter(function () { return this.value === type; }).next('label').click();
      } else {
        $('.selector-wrapper .bcpo-image-parent:first-of-type input[name="properties[LINING]"] + .bcpo-front-image-label').click();
      }
      liningPre();
    }
  }

  if ($('.popupContainer.measurement').length > 0) {
    var arr = [];
    $.each($('input[name="properties[Header Type]"]'), function (i, item) {
      arr.push($(item).val().trim().toUpperCase());
    });
    $.each($('.popupContainer .popupBox .popupBody .stepContainer .stepList .stepBox:first-of-type .option .optionItem'), function (i, item) {
      if (!arr.includes($(item).attr('data-value').toUpperCase())) {
        $(item).remove();
      }
    });
    $('#bcpo:not(.g-card) .selector-wrapper:has(select[name*="Width]"]) .bcpo-value, #bcpo:not(.g-card) .selector-wrapper:has(select[name*="Panel Length"]) .bcpo-value').after(`<span class="bcpo-value1"></span>`);
    // if (isIndoor) {
    // $('#bcpo:not(.g-card) .selector-wrapper:has([name*="Header Type"]) .bcpo-label label').after(`<span name="headerTypesPopup" onclick="TypesPopupOpen(event, this)">HEADER GUIDE</span>`);
    // }
    // if (!isDoor) {
    //   $('#bcpo:not(.g-card) .selector-wrapper:has(select[name*="Width]"]) .bcpo-label label, #bcpo:not(.g-card) .selector-wrapper:has(select[name*="Panel Length"]) .bcpo-label label').after(`<span onclick="popupOpen('.measurement')" click-data="SizeGuideStart">SIZE GUIDE</span>`);
    // }
  }

  showItemChange();
  sizeInit();

  if ($('.bcpo-image-parent:has(input[name="properties[Header Type]"][value="Triple French Pinch Pleat"])').length > 0) {
    $('.bcpo-image-parent:has(input[name="properties[Header Type]"][value="Triple French Pinch Pleat"])').insertAfter('.bcpo-image-parent:has(input[name="properties[Header Type]"][value="Double French Pinch Pleat"])');
  }
  if ($('.bcpo-image-parent:has(input[name="properties[Header Type]"][value="Euro Pleat"])').length > 0) {
    $('.bcpo-image-parent:has(input[name="properties[Header Type]"][value="Euro Pleat"])').insertAfter('.bcpo-image-parent:has(input[name="properties[Header Type]"][value="Goblet"])');
  }
  // HEADER TYPE 挂法
  // if (isIndoor) {
  //   $('.selector-wrapper:has(input[name="properties[Header Type]"])').append(`<div id="TypesPopup" class="btn" type="link" name="headerTypesPopup" onclick="TypesPopupOpen(event, this)">More Info About Our Header Types</div>`);
  // }
  // MEMORY TRAINING 高温定型
  $('.selector-wrapper:has(input[name="properties[MEMORY TRAINING]"])').append(`<div class="memoryTips">Note: Memory shape training is not available for your header choice. (Applicable headers: pinch pleats and grommets)</div>`);
  // SINGLE PANEL WIDTH / LENGTH 尺寸
  $('.selector-wrapper .bcpo-image-parent:first-of-type input[name="properties[Header Type]"] + label').click();

  // 这两条改名 + 上面的 Double Rod Pocket 过滤 + sizeInit() 的预设尺寸，在购物车编辑器
  // assets/component-cart-edit.js（normalize / presetsFor）里有副本；改这里要同步改那边，
  // 否则编辑后的行属性和产品页加购的对不上（后端按属性字符串计价）。
  $('.selector-wrapper input[value^="Back Tab"],.selector-wrapper input[value^=" Back Tab"]').attr('value', 'Back Tab & Rod Pocket');
  $('.selector-wrapper input[value^="4-IN-1"],.selector-wrapper input[value^=" 4-IN-1"]').attr('value', product.tags.includes("4 layer") ? 'Pleat Hook' : 'Pleat Hook & Clip Rings');
  // 改名后重挂一次挂法浮窗 + 实物图（onBcpoReady 那次看到的还是 4-IN-1，见 page_product_gallery.js）
  if (typeof attachHeaderTypePopups === 'function') attachHeaderTypePopups();
  // selectheader：集合页 Header Style 筛选带入的预选。值已在上面两行归一化，
  // 故匹配放在归一化之后；匹配不到时不点击，保留第 56 行设置的默认 header（静默忽略）。
  // 用 .filter 比对 value，避免把 URL 值插进选择器（", ], \ 等会破坏选择器并中断页面 JS）。
  if (searchParams.get('selectheader')) {
    var wantHeader = (searchParams.get('selectheader') || '').trim().toLowerCase();
    var $headerInputs = $('.selector-wrapper .bcpo-image-parent input[name="properties[Header Type]"]');
    // 先精确匹配；没有再前缀兜底：BCPO 把 "Back Tab" 归一成 "Back Tab & Rod Pocket"，
    // 而 filter 值（metaobject 标题）是 "Back Tab"。精确优先可避免 "Pleat Hook" 误中 "Pleat Hook & Clip Rings"。
    var $exact = $headerInputs.filter(function () {
      return (this.value || '').trim().toLowerCase() === wantHeader;
    });
    var $match = $exact.length ? $exact : $headerInputs.filter(function () {
      var v = (this.value || '').trim().toLowerCase();
      return wantHeader.length > 0 && v.indexOf(wantHeader) === 0;
    });
    var $selectHeader = $match.first().next('label');
    if ($selectHeader.length > 0) {
      $selectHeader.click();
    }
  }
  $('.selector-wrapper:has(select[name*="Panel Length"]) .bcpo-title').text('Single Panel Length:');

  resolvePanelSeamTip();
  updatePanelSeamTip();

  // 尺寸跨页记忆的品类（见 page_product_gallery.js restoreLastSize）：窗帘 / 咖啡帘 / 门帘尺寸语义不同，分开记。
  // 先定品类再走测量向导 —— 向导的 SHOP NOW 会调 onMeasurementGuideApplied 记下尺寸（它不经过 selectInputChange），
  // 品类必须先定好，向导填的尺寸才会被记住。
  const sizeMemoryKindName = isDoor ? 'door' : isCafe ? 'cafe' : 'curtain';
  setSizeMemoryKind(sizeMemoryKindName);
  const bfSelectedSize = readBfSelectedSize();
  let measurementGuideApplied = false;

  if (!bfSelectedSize && localStorage.getItem('measurementGuide')) {
    const option = JSON.parse(localStorage.getItem('measurementGuide'));
    const collType = {
      'Sheer': 'Sheer Curtains',
      'Curtain': "Custom Curtains",
      'Soundproof': "Soundproof Curtains"
    }
    const type = product.collections.filter(item => {
      return item.title == collType[option.collections];
    }).length > 0;

    if (type) {
      measurementGuideApplied = true;
      $(`.popupContainer .popupBox .popupBody .stepContainer .stepList .stepBox[data-type="width"] .optionItem[data-value="${option.isRod}"] .itemBox`).click();
      $.each(Object.keys(option), function (i, item) {
        if ($(`.popupContainer .popupBox .popupBody .stepContainer .stepList .stepBox[data-type="${item}"] .optionItem[data-value="${option[item]}"]`).length > 0) {
          $(`.popupContainer .popupBox .popupBody .stepContainer .stepList .stepBox[data-type="${item}"] .optionItem[data-value="${option[item]}"] .itemBox`).click();
        } else {
          $(`.popupContainer .popupBox .popupBody .stepContainer .stepList input[data-type="${item}"]`).val(option[item]);
        }
        $('.popupContainer .popupBox .popupBody .stepContainer .nextStep').click();
      });
      $('.popupContainer .popupBox .popupBody .stepContainer .btnList .btns .btn[type=black]').click();
    }
  }

  // 单位偏好 + 尺寸记忆都是锦上添花：出任何错都不能打断 bcpoLoad（后面还有 bcpoLoadType = true）。
  // 2026-10-01 staging 就踩过：refillSizesAfterUnitChange 里 matchNum(null) 抛错，带 CM 偏好打开 PDP 时初始化后半段全断。
  try {
    // 用户上次选的单位（CM/INCHES）沿用：切单位会重建尺寸控件并按 VO 值换算回填，所以放在恢复尺寸之前
    applyPreferredLengthUnit();
    // 本次 BF 明确选择的尺寸优先；其余入口保持测量向导 → 上次 PDP 尺寸的原有顺序。
    if (bfSelectedSize) {
      restoreBfSelectedSize(bfSelectedSize);
      // 已交给当前 PDP：移除一次性带入参数，避免 Clear/刷新重新覆盖用户随后编辑的尺寸。
      const url = new URL(window.location.href);
      ['bf_width', 'bf_length'].forEach(key => {
        searchParams.delete(key);
        url.searchParams.delete(key);
      });
      window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
    } else if (!measurementGuideApplied) restoreLastSize(sizeMemoryKindName);
  } catch (error) {
    console.error('size memory', error);
  }

  bcpoLoadType = true;
}

function buildPanelSeamTip () {
  const titleRaw = (product.fixed_height_vo_title || '').trim();
  const value = parseFloat(product.fixed_height_value);
  if (!titleRaw || !value) return '';

  const titleLower = titleRaw.toLowerCase();
  const isLength = titleLower.includes('length');
  const isWidth = titleLower.includes('width');
  if (!isLength && !isWidth) return '';

  const dimensionWord = isLength ? 'longer' : 'wider';
  const seamWord = isLength ? 'horizontal' : 'vertical';
  const type = isLength ? 'length' : 'width';

  return `<div class="msg lengthMaxTip panelSeamTip" data-type="${type}" data-title="${titleRaw}" data-max="${value}" style="display:none;">Panels ${dimensionWord} than ${value}" will feature a ${seamWord} seam due to fabric width limitations.</div>`;
}

function resolvePanelSeamTip () {
  const $tip = $('.panelSeamTip[data-type]');
  if (!$tip.length) return;

  const titleRaw = $tip.attr('data-title');
  if (!titleRaw) return;

  const normalizedTitle = titleRaw.replace(/:$/, '').trim().toLowerCase();
  let $select = $();

  // 1. 优先按 label 文本精确匹配
  const $wrapper = $('#bcpo .selector-wrapper').filter(function () {
    const wrapperTitle = $(this).find('.bcpo-title').text().replace(/:$/, '').trim().toLowerCase();
    return wrapperTitle === normalizedTitle;
  });
  if ($wrapper.length) {
    $select = $wrapper.find('select').first();
  }

  // 2. fallback：按 select name 精确匹配
  if (!$select.length) {
    $select = $(`select[name="properties[${titleRaw}]"]`);
  }

  if ($select.length) {
    $tip.attr('data-select-name', $select.attr('name'));
  }
}

function updatePanelSeamTip () {
  const $tip = $('.panelSeamTip[data-type]');
  if (!$tip.length) return;

  const maxInch = parseFloat($tip.attr('data-max')) || 0;
  const selectName = $tip.attr('data-select-name');
  if (!selectName) return;

  const $select = $(`select[name="${selectName}"]`);
  if (!$select.length || !$select.val()) return;

  const valueInches = matchNum($select.val()) || 0;
  $tip.css('display', valueInches > maxInch ? 'block' : 'none');
}

// 放在整个尺寸区底部，保留 .hasItem 的 last-child 契约及展开状态。
function placeMotorTrackNotice(headerValue) {
  const notice = document.querySelector('[data-track-pdp]');
  if (!notice) return;
  const root = document.querySelector('#bcpo:not(.g-card)');
  const lengthField = root?.querySelector('select[name*="Panel Length"]')?.closest('.selector-wrapper');
  if (isDoor || !lengthField || notice.closest('.g-card')) {
    notice.hidden = true;
    return;
  }
  // Fraction 逻辑通过字段的 next() 取值；提示需排在 Length Fraction 和尺寸说明之后。
  const dimensionItems = [...lengthField.parentElement.children].filter(item =>
    item === lengthField || item.matches('.measurementBox, .measurementText') ||
    item.matches('.selector-wrapper') && item.querySelector('[name*="Length Fraction"]')
  );
  const anchor = dimensionItems[dimensionItems.length - 1];
  if (anchor.nextElementSibling !== notice) anchor.after(notice);
  const header = headerValue ?? root.querySelector('input[name="properties[Header Type]"]:checked')?.value;
  notice.hidden = header === 'Ripple Fold with Tape Buckle';
}

function sizeInit () {
  $('.hasItem .item, .hasItem .msg, .hasItem .size-help').remove();
  
  // Panel Width
  var customSizeWidth = [];
  if (product.tags.includes("Cafe Curtains")) {
    customSizeWidth = [20, 40, 50, 60];
  } else {
    customSizeWidth = unitType == '"' ? [25, 50, 70, 90, 100] : [46, 52, 66, 90, 112];
  }
  // Panel Length
  var customSizeLength = [];
  if (product.tags.includes("Cafe Curtains")) {
    customSizeLength = [25, 45, 55];
  } else {
    customSizeLength = unitType == '"' ? [84, 96, 108] : [54, 72, 90];
  }

  var widthStr = [], heightStr = [];
  // if (isIndoor) {
  widthStr.push(`<div class="msg fullTips">${measurementMsgChange1($('.selector-wrapper .bcpo-image-parent:first-of-type input[name="properties[Header Type]"]').val(), isDoor ? 'Door' : isSheer ? 'Sheer' : isSoundproof ? 'Soundproof' : 'Curtain')}</div>`);
  // }

  const panelSeamTip = buildPanelSeamTip();
  const panelSeamTitleLower = (product.fixed_height_vo_title || '').trim().toLowerCase();
  if (panelSeamTip && panelSeamTitleLower.includes('width')) {
    widthStr.push(panelSeamTip);
  }

  if (!isDoor) {
    $.each(customSizeWidth, function (i, item) {
      itemUnit = item;
      if (unitType != '"') {
        const num = Math.round(item * lengthRate);
        itemUnit = num;
      }
      if (item >= SelectRange($('select[name*="Width]"]')).min && item <= SelectRange($('select[name*="Width]"]')).max) {
        widthStr.push(`<div class="item">`);
        widthStr.push(`<div class="itemBox bcpo-FixedSize-Width" data-num="${item}" data-text="${itemUnit}" data-unit='${unitType}'>`);
        widthStr.push(`</div>`);
        widthStr.push(`</div>`);
      }
    });
  }
  widthStr.push(`<div class="item has-input">`);
  widthStr.push(`<div class="itemBox" click-data="properties[Width]">`);
  widthStr.push(`<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
  <g clip-path="url(#clip0_715_675)">
    <path d="M8.63819 1L11 3.36185L3.50006 10.8618H1.00006V8.5L8.63819 1Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M7.00006 2.64453L9.35716 5.00167" stroke="black" stroke-width="1.02857" stroke-linecap="round" stroke-linejoin="round"/>
  </g>
  <defs>
    <clipPath id="clip0_715_675">
      <rect width="12" height="12" fill="white"/>
    </clipPath>
  </defs>
</svg>${inputRange($('select[name*="Width]"]'), clientWidth > 1080 ? 'ENTER WIDTH' : 'WIDTH')}`);
  widthStr.push(`</div>`);
  widthStr.push(`</div>`);

  $('select[name*="Width]"]').before(widthStr.join('')).closest('div').addClass('hasItem');

  if (panelSeamTip && panelSeamTitleLower.includes('length')) {
    heightStr.push(panelSeamTip);
  }

  if (!isDoor) {
    $.each(customSizeLength, function (i, item) {
      itemUnit = item;
      if (unitType != '"') {
        const num = Math.round(item * lengthRate);
        itemUnit = num;
      }
      if (item >= SelectRange($('select[name*="Length"]')).min && item <= SelectRange($('select[name*="Length"]')).max) {
        heightStr.push(`<div class="item">`);
        heightStr.push(`<div class="itemBox bcpo-FixedSize-Length" data-num="${item}" data-text="${itemUnit}" data-unit='${unitType}'>`);
        heightStr.push(`</div>`);
        heightStr.push(`</div>`);
      }
    });
  }
  heightStr.push(`<div class="item has-input">`);
  heightStr.push(`<div class="itemBox" click-data="properties[Length]">`);
  heightStr.push(`<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
  <g clip-path="url(#clip0_715_675)">
    <path d="M8.63819 1L11 3.36185L3.50006 10.8618H1.00006V8.5L8.63819 1Z" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M7.00006 2.64453L9.35716 5.00167" stroke="black" stroke-width="1.02857" stroke-linecap="round" stroke-linejoin="round"/>
  </g>
  <defs>
    <clipPath id="clip0_715_675">
      <rect width="12" height="12" fill="white"/>
    </clipPath>
  </defs>
</svg>${inputRange($('select[name*="Length"]'), clientWidth > 1080 ? 'ENTER LENGTH' : 'LENGTH')}`);
  heightStr.push(`</div>`);
  heightStr.push(`</div>`);

  $('select[name*="Length"]').before(heightStr.join('')).closest('div').addClass('hasItem');

  $('#bcpo:not(.g-card).bcpo-square .bcpo-default>div:last-child .item .itemBox[data-num]').on('click', function () {
    const text = $(this).attr('data-text');
    $(this).closest('.hasItem').find('active').removeClass('actove');
    $(this).parent().parent().find('.selectInput').val(`${text}${unitType}`).change();
    $(this).addClass('active');
    // $(this).parent().parent().find('select:not(.selectInput)').val(`${$(this).attr('data-num')}"`).change();
  });

  updatePanelSeamTip();
  placeMotorTrackNotice();
}

// 尺寸示意初始展示
function measurementsInit () {
  var str = [];

  str.push(`<div class="measurementBox">`);
  const headerRingsType = headerHasRings.filter(item => {
    return $('.selector-wrapper .bcpo-image-parent:first-of-type input[name="properties[Header Type]"]').val().includes(item);
  }).length > 0;
  // 挂法示意图
  if (isIndoor) {
    str.push(`<img src="/cdn/shop/files/page_product-curtainHeight${headerRingsType ? '1' : ''}.png" />`);
  }
  // 提示文案
  str.push(`<div class="tips">`);
  // str.push(`<p>Panel Width = Desired Curtain Coverage Width${ isDoor ? '' : ' * <a href="/pages/helpcenter?type=1.3." target="_blank">Fullness Ratio</a>'} / Panel Quantity</p>`);
  // if (isSoundproof) {
  //   str.push(`<p>According to your chosen header type (Grommet Top), we recommend a fullness ratio of 1.5x to 2x, with 2x for enhanced soundproofing.</p>`);
  //   str.push(`<p style="color:#8c8c8c;">To ensure soundproof effectiveness:<br/><p>· The curtain should completely and tightly cover the entire window.</p><p>The curtain should touch the floor, with an additional 4-8 inches added for full coverage.</p></p>`);
  // }
  str.push(measurementMsgChange($('.selector-wrapper .bcpo-image-parent:first-of-type input[name="properties[Header Type]"]').val(), isDoor ? 'Door' : isSheer ? 'Sheer' : isSoundproof ? 'Soundproof' : 'Curtain'));
  str.push(`</div>`);

  str.push(`</div>`);

  $('.selector-wrapper:has(select[name*="Panel Length"])').after(str.join(''));
}

var oldHeaderType = "";
$('.product__info-container').on("click", "#bcpo .single-option-selector .bcpo-front-image-label", function (event) {
  if ($(this).attr('readonly') == 'readonly') {
    return;
  }
  var $parent = $(this).closest('.selector-wrapper');
  var $optionsparent = $(this).closest('.bcpo-image-parent');
  var $item = $optionsparent.find('input.bcpo-front-image-option');
  if ($item.attr('name').includes('name0')) {
    // Color
    liningPre($item.val(), $('input[name="properties[LINING]"]:checked').val());
  }
  if ($parent.find('.bcpo-label span.bcpo-title').text() == 'Header Type:') {
    // Header
    if (resultType) {
      // 测量弹窗走完全程
      $(`.popupContainer .popupBox .popupBody .stepContainer .stepList .stepBox:first-of-type .option .optionItem[data-value="${$item.val()}"] .itemBox`).click();
      resultChange();
      $('.popupContainer .popupBox .popupBody .stepContainer .btnList .btns .btn[type=black]').click();
    }
    var currentHeader = $item.val().toLowerCase();
    var currentHeaderText = currentHeader.replace(/ /g, '_').replace(/-/g, '_').replace(/&/g, '_') || 'grommet_top';
    const headerRingsType = headerHasRings.filter(item => {
      return $item.val().includes(item);
    }).length > 0;
    // 更新挂法示意图
    $('.measurementBox img').attr('src', `/cdn/shop/files/page_product-curtainHeight${headerRingsType ? '1' : ''}.png`);
    if (stepType) {
      resultChange(currentHeader);
    }
    // 挂法测量方式
    $('#bcpo:not(.g-card) .selector-wrapper[type=measurement] .bcpo-box .bcpo-details .detailsBox[type="Height"] > img').attr('src', `/cdn/shop/files/page_product_height${headerType_measurement.includes(currentHeader) ? '' : '1'}.png`);
    if (stepType && (headerType_measurement.includes(currentHeader) != headerType_measurement.includes(oldHeaderType.toLowerCase()))) {
      // 测量流程走完后更新挂法,如果测量方式不一致,清除除Width以外的操作
      productMeasurementClean();
      $('#bcpo:not(.g-card) .selector-wrapper[type=measurement]').addClass('verify');
      $('#bcpo:not(.g-card) .selector-wrapper[type=measurement] .bcpo-label').addClass('active');
    }

    // 更新文案
    $('.measurementBox .tips').html(measurementMsgChange($item.val(), isDoor ? 'Door' : isSheer ? 'Sheer' : isSoundproof ? 'Soundproof' : 'Curtain'));
    $('#bcpo:not(.g-card).bcpo-square .bcpo-default>div:last-child .fullTips').html(measurementMsgChange1($item.val(), isDoor ? 'Door' : isSheer ? 'Sheer' : isSoundproof ? 'Soundproof' : 'Curtain'));

    // 高温定型选项状态
    const isMemoryType = isNotMemory && $('[name="properties[LINING]"]:checked').length > 0 && $('[name="properties[LINING]"]:checked').val() != 'Unlined';

    $('#bcpo:not(.g-card) .memoryTips').css('display', isMemoryType || headerType_memory.includes(currentHeader) ? 'flex' : 'none');

    if (headerType_memory.includes(currentHeader)) {
      $('#bcpo .single-option-selector .bcpo-front-image-option[name="properties[Additional Options][]" i][value="Pleat shape retention treatment"]').prop('checked', false);
    }
    $('#bcpo:not(.g-card) .selector-wrapper[type=memory][name="properties[MEMORY TRAINING]"] .bcpo-box .bcpo-item .item[data-value="Yes"]').removeClass('active').attr('disabled', isMemoryType || headerType_memory.includes(currentHeader));
    $('#bcpo .single-option-selector .bcpo-front-image-option[name="properties[Additional Options][]" i][value="Pleat shape retention treatment"]').parent().removeClass('active').attr('readonly', isMemoryType || headerType_memory.includes(currentHeader));
    $('#bcpo .single-option-selector .bcpo-front-image-option[name="properties[Additional Options][]" i][value="Pleat shape retention treatment"]').attr('disabled', isMemoryType || headerType_memory.includes(currentHeader));
    $('#bcpo .single-option-selector .bcpo-front-image-option[name="properties[MEMORY TRAINING]"][value="Memory Trained"]').parent().removeClass('active').attr('readonly', isMemoryType || headerType_memory.includes(currentHeader));
    // if (headerType_memory.includes($item.val().toLowerCase())) {
    //   $('#bcpo .single-option-selector .bcpo-front-image-option[name="properties[MEMORY TRAINING]"][value="None"]').click();
    //   $('#bcpo:not(.g-card) .selector-wrapper[type=memory][name="properties[MEMORY TRAINING]"] .bcpo-box .bcpo-item .item[data-value="No"]').click();
    // }
    oldHeaderType = $item.val();
    if (!$item.closest('.g-card').length) placeMotorTrackNotice($item.val());
  }
  if ($item.attr('name').includes('LINING')) {
    // 内衬
    liningPre($('input[name="name0"]:checked').val(), $item.val());
  }

  // $(`#bcpo:not(.g-card) .selector-wrapper[name="${ $item.attr('name') }"] .bcpo-value`).html($parent.find('.bcpo-value').html());
  $parent.removeClass('verify');
  $('input.quantity__input').change();
})

// 创建观察器实例
const bcpoObserverShades = new MutationObserver(mutations => {
  const targetElement = document.querySelector('#bcpo');
  if (targetElement) {
    bcpoObserverShades.disconnect(); // 停止观察
    bcpoLoad();
    initMeasurementInputValidate()
  }
});

// 如果 #bcpo 已经存在，直接处理；否则监听 DOM 变化
if (document.querySelector('#bcpo')) {
  bcpoLoad();
  initMeasurementInputValidate()
} else {
  // 配置观察选项（观察整个文档的子节点变化）
  bcpoObserverShades.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
}


/**
 * 门帘产品添加校验规则 (模版: template-product-doors-measurement )
 * 尺寸输入框校验封装函数
 */
function initMeasurementInputValidate() {
    const container = document.querySelector('.template-product-doors-measurement .bcpo');
    const inputList = container ? container.querySelectorAll('input.selectInput') : [];
    const addToCartBtn = document.querySelector('#AddToCart .btn');
    console.log(container)
    console.log(inputList)
    console.log(addToCartBtn)

    // 没有找到对应元素直接退出
    if (!container || !addToCartBtn || inputList.length === 0) {
        return;
    }

    // 单个输入框校验
    function validateInput(input) {
        const val = parseFloat(input.value);
        const min = parseFloat(input.min);
        const max = parseFloat(input.max);
        return !(isNaN(val) || val < min || val > max);
    }

    // 获取第一个不合法的输入框
    function getFirstInvalidInput() {
        for (const input of inputList) {
            if (!validateInput(input)) {
                return input;
            }
        }
        return null;
    }

    // 更新购物车按钮禁用状态
    function refreshBtnStatus() {
        const invalidEl = getFirstInvalidInput();
        addToCartBtn.disabled = !!invalidEl;
    }

    // 绑定输入监听
    inputList.forEach(input => {
        input.removeEventListener('input', refreshBtnStatus);
        input.addEventListener('input', refreshBtnStatus);
    });

    // 初始化校验
    refreshBtnStatus();
}
